// extracted by mini-css-extract-plugin
export default {"content":"page_content__QniB0","button-content":"page_button-content__Pl+zE"};